<ng-container *ngIf="totalItems$ | async as total">
  <ng-container *ngIf="total > 0">
    <div class="wrapper">
      <div [routerLink]="['/marketplace', 'basket']" class="btn btn-outline-success d-flex align-items-center gap-2">
        <fa-icon [icon]="cartIcon" [fixedWidth]="true"></fa-icon>
        <span class="badge rounded-pill bg-danger">
          {{ total }}
        </span>
      </div>
    </div>
  </ng-container>
</ng-container>
